export default __webpack_public_path__ + "static/media/schedularI.89f5c25b.svg";